export default "__VITE_ASSET__Bl2V6mgb__"